// src/store/keyword.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';
import { keywordDataApi } from 'store/keyword';
import {
  KeywordPostResponse,
  MissionKeywordPostRequest,
  MissionKeywordPostResponse,
} from 'types/keyword';

import type { AreaStatus } from 'types/spot';

type State = {
  isInitialize: boolean; // Suspenseと連動させるためのフラグ
  keyword: string;
  result: boolean;
  progress?: AreaStatus;
};

const initialState: State = {
  keyword: '',
  isInitialize: false,
  result: false,
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

// RTK Queryの設定
export const missionKeywordDataApi = createApi({
  reducerPath: 'missionKeywordDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['MissionKeyword'],
  endpoints: builder => ({
    sendMissionKeywordData: builder.mutation<MissionKeywordPostResponse, MissionKeywordPostRequest>(
      {
        query: ({ keyword, mission }) => ({
          url: `/mission-keyword?mission=${mission}`,
          method: 'POST',
          body: { keyword },
        }),
        invalidatesTags: ['MissionKeyword'],
      }
    ),
  }),
});

// エンドポイント毎にカスタムhooksが作成される
export const { useSendMissionKeywordDataMutation } = missionKeywordDataApi;

const missionKeyword = createSlice({
  name: 'missionKeyword',

  initialState,

  reducers: {
    updateMissionKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload;
    },
    updateMissionProgress: (state, action: PayloadAction<AreaStatus>) => {
      state.progress = action.payload;
    },
  },

  extraReducers: builder => {
    // POST後に状態を取得
    builder.addMatcher(
      keywordDataApi.endpoints.sendKeywordData.matchFulfilled,
      (state, action: PayloadAction<KeywordPostResponse>) => {
        console.log('POST keyword fulfilled');

        const { result, progress } = action.payload;

        return {
          ...state,
          result,
          progress,
          isInitialize: true,
        };
      }
    );
    // POST失敗
    builder.addMatcher(keywordDataApi.endpoints.sendKeywordData.matchRejected, state => {
      console.error('POST keyword rejected');
    });
  },
});

// Action Creators
export const { updateMissionKeyword, updateMissionProgress } = missionKeyword.actions;

// Reducer
export default missionKeyword.reducer;
